import { create } from "zustand";
import { FlowStepData } from "@hilos/types/flow";

interface FlowClipboardStore {
  copiedStep: FlowStepData | null;
  setCopiedStep: (step: FlowStepData | null) => void;
}

const useFlowClipboardStore = create<FlowClipboardStore>((set) => ({
  copiedStep: null,
  setCopiedStep: (copiedStep = null) => set({ copiedStep }),
}));

export default useFlowClipboardStore;
